import { createPaymentItemSchema, zSchema } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TCreatePaymentItemRequest = zSchema.infer<
  typeof createPaymentItemSchema
>;

export type TCreatePaymentItemResponse = zSchema.infer<
  typeof createPaymentItemSchema
> & {
  paymentItemID: string;
};

export const createPaymentItem = (axios: IAxiosInstance) => {
  return async (requestBody: TCreatePaymentItemRequest) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreatePaymentItemResponse>
    >("payment-items", requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
